const courseEditrstyles = {
    header: {
      textAlign: "center",
      fontSize: "28px",
      marginBottom: "25px",
    },
    selectRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "15px",
    },
    selectContainer: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      flex: 1,
    },
    label: {
      fontSize: "16px",
      fontWeight: "bold",
    },
    select: {
      width: "100%",
      padding: "8px",
      fontSize: "14px",
      borderRadius: "5px",
      border: "1px solid #ccc",
    },
    editActionsContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "10px",
      paddingTop: "10px",
    },
    editButtonContainer: {
      display: "flex",
      gap: "10px",
    },
    saveResetContainer: {
      display: "flex",
      gap: "10px",
    },
    button: {
      padding: "10px 15px",
      backgroundColor: "#007BFF",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
    },
    activeButton: {
      backgroundColor: "#0056b3",
      boxShadow: "0 0 5px rgba(0,0,0,0.3)",
    },
    resetButton: {
      padding: "10px 15px",
      backgroundColor: "#FF5733",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
    },
    deleteButton: {
      padding: "10px 15px",
      backgroundColor: "#9e9e9e",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
    },
    textarea: {
      width: "100%",
      height: "calc(100vh - 200px)",
      padding: "10px",
      fontSize: "14px",
      fontFamily: "monospace",
    },
    iframe: {
      width: "100%",
      height: "calc(100vh - 200px)",
      border: "1px solid #ccc",
    },
  };
  
  export default courseEditrstyles;